import './App.css';
import ScreenNav from './components/ScreenNav';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AppDesktop = () => {
    return (
        <div>
            <ScreenNav />
            <ToastContainer position="bottom-right" autoClose={1500} pauseOnHover={false} />
        </div>
    );
};

export default AppDesktop;
